const country = [{
		name: '中国大陆'
	},
	{
		name: '中国台湾地区'
	},
	{
		name: '中国香港'
	},
	{
		name: '中国澳门'
	},
	{
		name: '阿尔巴尼亚'
	},
	{
		name: '安哥拉'
	},
	{
		name: '阿根廷'
	},
	{
		name: '澳大利亚'
	},
	{
		name: '奥地利'
	},
	{
		name: '阿塞拜疆'
	},
	{
		name: '巴哈马'
	},
	{
		name: '巴林'
	},
	{
		name: '白俄罗斯'
	},
	{
		name: '比利时'
	},
	{
		name: '伯利兹'
	},
	{
		name: '贝宁'
	},
	{
		name: '玻利维亚'
	},
	{
		name: '巴西'
	},
	{
		name: '英属维尔京群岛'
	},
	{
		name: '文莱'
	},
	{
		name: '保加利亚'
	},
	{
		name: '布基纳法索'
	},
	{
		name: '柬埔寨'
	},
	{
		name: '喀麦隆'
	},
	{
		name: '佛得角'
	},
	{
		name: '开曼群岛'
	},
	{
		name: '乍得'
	},
	{
		name: '智利'
	},
	{
		name: '哥伦比亚'
	},
	{
		name: '科摩罗'
	},
	{
		name: '哥斯达黎加'
	},
	{
		name: '克罗地亚'
	},
	{
		name: '塞浦路斯'
	},
	{
		name: '丹麦'
	},
	{
		name: '吉布提'
	},
	{
		name: '埃及'
	},
	{
		name: '萨尔瓦多'
	},
	{
		name: '赤道几内亚'
	},
	{
		name: '爱沙尼亚'
	},
	{
		name: '芬兰'
	},
	{
		name: '法国'
	},
	{
		name: '加蓬'
	},
	{
		name: '冈比亚'
	},
	{
		name: '格鲁吉亚'
	},
	{
		name: '德国'
	},
	{
		name: '希腊'
	},
	{
		name: '格林纳达'
	},
	{
		name: '危地马拉'
	},
	{
		name: '几内亚'
	},
	{
		name: '几内亚比绍'
	},
	{
		name: '圭亚那'
	},
	{
		name: '洪都拉斯'
	},
	{
		name: '匈牙利'
	},
	{
		name: '印度'
	},
	{
		name: '印度尼西亚'
	},
	{
		name: '爱尔兰'
	},
	{
		name: '以色列'
	},
	{
		name: '意大利'
	},
	{
		name: '牙买加'
	},
	{
		name: '日本'
	},
	{
		name: '约旦'
	},
	{
		name: '肯尼亚'
	},
	{
		name: '科威特'
	},
	{
		name: '吉尔吉斯斯坦'
	},
	{
		name: '拉脱维亚'
	},
	{
		name: '莱索托'
	},
	{
		name: '立陶宛'
	},
	{
		name: '卢森堡'
	},
	{
		name: '马达加斯加'
	},
	{
		name: '马拉维'
	},
	{
		name: '马来西亚'
	},
	{
		name: '马尔代夫'
	},
	{
		name: '马里'
	},
	{
		name: '毛里塔尼亚'
	},
	{
		name: '毛里求斯'
	},
	{
		name: '墨西哥'
	},
	{
		name: '摩尔多瓦'
	},
	{
		name: '蒙古'
	},
	{
		name: '摩洛哥'
	},
	{
		name: '莫桑比克'
	},
	{
		name: '纳米比亚'
	},
	{
		name: '荷兰'
	},
	{
		name: '孟加拉人民共和‘'
	},
	{
		name: '新西兰'
	},
	{
		name: '尼加拉瓜'
	},
	{
		name: '尼日尔'
	},
	{
		name: '尼日利亚'
	},
	{
		name: '挪威'
	},
	{
		name: '阿曼'
	},
	{
		name: '巴勒斯坦'
	},
	{
		name: '巴拿马'
	},
	{
		name: '巴布亚新几内亚'
	},
	{
		name: '秘鲁'
	},
	{
		name: '菲律宾'
	},
	{
		name: '波兰'
	},
	{
		name: '葡萄牙'
	},
	{
		name: '卡塔尔'
	},
	{
		name: '罗马尼亚'
	},
	{
		name: '俄罗斯'
	},
	{
		name: '卢旺达'
	},
	{
		name: '沙特阿拉伯'
	},
	{
		name: '塞内加尔'
	},
	{
		name: '塞尔维亚'
	},
	{
		name: '塞舌尔'
	},
	{
		name: '塞拉利昂'
	},
	{
		name: '新加坡'
	},
	{
		name: '斯洛伐克'
	},
	{
		name: '斯洛文尼亚'
	},
	{
		name: '南非'
	},
	{
		name: '韩国'
	},
	{
		name: '西班牙'
	},
	{
		name: '斯里兰卡'
	},
	{
		name: '苏里南'
	},
	{
		name: '斯威士兰'
	},
	{
		name: '瑞典'
	},
	{
		name: '瑞士'
	},
	{
		name: '塔吉克斯坦'
	},
	{
		name: '坦桑尼亚'
	},
	{
		name: '泰国'
	},
	{
		name: '多哥'
	},
	{
		name: '特立尼达和多巴‘'
	},
	{
		name: '突尼斯'
	},
	{
		name: '土耳其'
	},
	{
		name: '土库曼斯坦'
	},
	{
		name: '乌干达'
	},
	{
		name: '乌克兰'
	},
	{
		name: '阿联酋'
	},
	{
		name: '英国'
	},
	{
		name: '乌拉圭'
	},
	{
		name: '美国/加拿大'
	},
	{
		name: '乌兹别克斯坦'
	},
	{
		name: '委内瑞拉'
	},
	{
		name: '越南'
	},
	{
		name: '也门'
	},
	{
		name: '赞比亚'
	},
	{
		name: '津巴布韦'
	},
	{
		name: '萨摩亚'
	},
	{
		name: '捷克共和国'
	},
];
const qyTyoes = [{
		name: '外商投资企业'
	},
	{
		name: '股份合作企业'
	},
	{
		name: '港澳台企业'
	},
	{
		name: '个人独资企业'
	},
	{
		name: '国有企业'
	},
	{
		name: '集体所有制企业'
	},
	{
		name: '股份有限责任公司'
	},
	{
		name: '私营企业'
	},
	{
		name: '有限合伙企业'
	},
	{
		name: '特殊普通合伙企业'
	},
	{
		name: '外商企业'
	},
	{
		name: '合作社'
	},
	{
		name: '民办非企业单位'
	},
	{
		name: '股份有限公司'
	},
	{
		name: '有限责任公司'
	},
];
const shFwScopes = [{
		name: '全球'
	},
	{
		name: '亚洲'
	},
	{
		name: '欧洲'
	},
	{
		name: '北美洲'
	},
	{
		name: '南美洲'
	},
	{
		name: '非洲'
	},
	{
		name: '大洋洲'
	},
	{
		name: '南极洲'
	},
	{
		name: '中国'
	},
	{
		name: '华东'
	},
	{
		name: '华北'
	},
	{
		name: '华南'
	},
	{
		name: '东北'
	},
	{
		name: '西南'
	},
	{
		name: '华中'
	},
	{
		name: '西北'
	},
]

export default {
	country,
	qyTyoes,
	shFwScopes,
}
